import Geocode from "react-geocode";
import React from "react";



export default  function Geosimples(props,end) {

  var geo1;
  Geocode.setApiKey("AIzaSyA0RbxlQeRjG7ZPfUSz1e8KV4oWzqm8Ye8");

  // set response language. Defaults to english.
  Geocode.setLanguage("pt-BR");
  
  // set response region. Its optional.
  // A Geocoding request with region=es (Spain) will return the Spanish city.
  Geocode.setRegion("br");
  
  // set location_type filter . Its optional.
  // google geocoder returns more that one address for given lat/lng.
  // In some case we need one address as response for which google itself provides a location_type filter.
  // So we can easily parse the result for fetching address components
  // ROOFTOP, RANGE_INTERPOLATED, GEOMETRIC_CENTER, APPROXIMATE are the accepted values.
  // And according to the below google docs in description, ROOFTOP param returns the most accurate result.
  Geocode.setLocationType("ROOFTOP");
  
  // Enable or disable logs. Its optional.
  Geocode.enableDebug();
  




 
Geocode.fromAddress(end.description).then(
  (response) => {
    //const { lat, lng } = response.results[0].geometry.location;
    geo1=response.results[0].geometry.location;
    console.error(geo1);
    
    props(geo1);
    
  },
  (error) => {
    console.error(error);
  }
);

console.log(geo1);
console.log(geo1);
return(
  geo1
)



}
export {Geosimples}


/*

Geocode.fromAddress(props.saidam.description).then(
  (response) => {
    const { lat, lng } = response.results[0].geometry.location;
    geo2={lat:lat, lng:lng};
    props.setageosaida(geo1)
    
    console.error(geo2);
  },
  (error) => {
    console.error(error);
  }
);



function geolistaida(){
geo3=[];
for (let index = 0; index < props.lidam.length; index++) {

  Geocode.fromAddress(props.lidam.description).then(
    (response) => {
      const { lat, lng } = response.results[0].geometry.location;
      geo3.push({lat:lat, lng:lng});
      
     
    },
    (error) => {
      console.error(error);
    }
  );
  
}
props.setageoparadasida(geo4);

  }

  if((props.lidam.length>0)&&(props.lidam[0]!='')){
  geolistaida()
  
    }
  

function geolistavolta(){
  geo4=[];
  for (let index = 0; index < props.lvoltam.length; index++) {

    Geocode.fromAddress(props.lvoltam.description).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        geo4.push({lat:lat, lng:lng});
        
       
      },
      (error) => {
        console.error(error);
      }
    );
    
    }
  props.setageoparadasvolta(geo4);
  }

  if((props.lvoltam.length>0)&&(props.lvoltam[0]!='')){
  geolistavolta()
  
    }




return(false)




}

*/